/**
 * A loading placeholder shaped roughly like the content it replaces (see `.huaca-skeleton` in
 * @huaca/ui), so the layout does not jump when the real content arrives. Held in role="status" with a
 * visually-hidden label so a screen reader hears "loading" instead of silence — the a11y gap the bare
 * "טוען…" text left. Pass `title` for a header bar and `lines` for the body rows.
 */
export function Skeleton({ lines = 3, title = false, label = 'טוען…' }: { lines?: number; title?: boolean; label?: string }) {
  return (
    <div role="status" aria-live="polite" data-testid="skeleton">
      <span className="huaca-visually-hidden">{label}</span>
      {title && <div className="huaca-skeleton huaca-skeleton-title" />}
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="huaca-skeleton huaca-skeleton-line" />
      ))}
    </div>
  );
}
